/** @file Marks every held key as released and fires the up handlers (blur, detach, macOS Meta quirk). */
import { fireHolds } from './fireHolds';
import { keyState } from './keyState';

/** Clears the held set first, then fires `up` for each code, so handlers see a consistent state. */
export function releaseAll(): void {
  const codes = [...keyState.held];
  keyState.held.clear();
  for (const code of codes) fireHolds(code, 'up');
}
